import React from "react";

// reactstrap components
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
} from "reactstrap";
// core components
import InfoNavbar from "components/Navbars/InfoNavbar.js";
import FooterBlack from "components/Footers/FooterBlack.js";
import Buttons from "components/Headers/Buttons.js";
import SectionJavaScript from "views/index-sections/SectionJavaScript.js";
import Particles from "components/Particles.js";

function Discover() {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("discover");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("discover");
    };
  });
  return (
    <>
      <InfoNavbar />
      <br/>
      <Buttons/>
      <div style={{height:"3px", backgroundColor: "gold"}} />
      <div className="wrapper">
        <div className="wrapper">

          <div className="main">
            <div className="section">
<Particles/>

            <SectionJavaScript/>


              <Container>
                <Row>
                  <Col className="ml-auto mr-auto text-center" md="6" xs="12">
               
                  </Col>
                </Row>
                <Row className="items-row">
                  <Col className="ml-auto" md="4" sm="4">
                    <Card className="card-plain text-center">
                      <div className="card-image">
                        <a href="#pablo" onClick={(e) => e.preventDefault()}>
                          <img
                            alt="..."
                            className="img-rounded img-responsive"
                            src={require("assets/img/sb3.jpg")}
                          />
                        </a>
                        <CardBody className="details-center">
                          <a href="#pablo" onClick={(e) => e.preventDefault()}>
                            {/* <div className="author">
                              <img
                                alt="..."
                                className="img-circle img-no-padding img-responsive"
                                src={require("assets/img/disc2.jpeg")}
                              />
                              <div className="text">
                                <span className="name">Jane Doe</span>
                                <div className="meta">Drawn on 23 Nov</div>
                              </div>
                            </div> */}
                          </a>
                        </CardBody>
                      </div>
                    </Card>
                  </Col>
                  <Col md="4" sm="4">
                    <Card className="card-plain text-center">
                      <div className="card-image">
                        <a href="#pablo" onClick={(e) => e.preventDefault()}>
                          <img
                            alt="..."
                            className="img-rounded img-responsive"
                            src={require("assets/img/sb4.jpg")}
                          />
                        </a>
                        <CardBody className="details-center">
                          <a href="#pablo" onClick={(e) => e.preventDefault()}>
                           
                          </a>
                        </CardBody>
                      </div>
                    </Card>
                  </Col>
                  <Col className="mr-auto" md="4" sm="4">
                    <Card className="card-plain text-center">
                      <div className="card-image">
                        <a href="#pablo" onClick={(e) => e.preventDefault()}>
                          <img
                            alt="..."
                            className="img-rounded img-responsive"
                            src={require("assets/img/sb5.jpg")}
                          />
                        </a>
                        <CardBody className="details-center">
                          {/* <a href="#pablo" onClick={(e) => e.preventDefault()}>
                            <div className="author">
                              <img
                                alt="..."
                                className="img-circle img-no-padding img-responsive"
                                src={require("assets/img/disc3.jpeg")}
                              />
                              <div className="text">
                                <span className="name">Chet Faker</span>
                                <div className="meta">Drawn on 20 Jan</div>
                              </div>
                            </div>
                          </a> */}
                        </CardBody>
                      </div>
                    </Card>
                  </Col>
                </Row>
                <Row className="items-row">
                  <Col className="ml-auto" md="4" sm="4">
                    <Card className="card-plain text-center">
                      <div className="card-image">
                        <a href="#pablo" onClick={(e) => e.preventDefault()}>
                          <img
                            alt="..."
                            className="img-rounded img-responsive"
                            src={require("assets/img/disc1.jpeg")}
                          />
                        </a>
                        <CardBody className="details-center">
                          <a href="#pablo" onClick={(e) => e.preventDefault()}>
                            {/* <div className="author">
                              <img
                                alt="..."
                                className="img-circle img-no-padding img-responsive"
                                src={require("assets/img/disc2.jpeg")}
                              />
                              <div className="text">
                                <span className="name">Jane Doe</span>
                                <div className="meta">Drawn on 23 Nov</div>
                              </div>
                            </div> */}
                          </a>
                        </CardBody>
                      </div>
                    </Card>
                  </Col>
                  <Col md="4" sm="4">
                    <Card className="card-plain text-center">
                      <div className="card-image">
                        <a href="#pablo" onClick={(e) => e.preventDefault()}>
                          <img
                            alt="..."
                            className="img-rounded img-responsive"
                            src={require("assets/img/disc22.jpeg")}
                          />
                        </a>
                        <CardBody className="details-center">
                          <a href="#pablo" onClick={(e) => e.preventDefault()}>
                           
                          </a>
                        </CardBody>
                      </div>
                    </Card>
                  </Col>
                  <Col className="mr-auto" md="4" sm="4">
                    <Card className="card-plain text-center">
                      <div className="card-image">
                        <a href="#pablo" onClick={(e) => e.preventDefault()}>
                          <img
                            alt="..."
                            className="img-rounded img-responsive"
                            src={require("assets/img/disc3.jpeg")}
                          />
                        </a>
                        <CardBody className="details-center">
                          {/* <a href="#pablo" onClick={(e) => e.preventDefault()}>
                            <div className="author">
                              <img
                                alt="..."
                                className="img-circle img-no-padding img-responsive"
                                src={require("assets/img/disc3.jpeg")}
                              />
                              <div className="text">
                                <span className="name">Chet Faker</span>
                                <div className="meta">Drawn on 20 Jan</div>
                              </div>
                            </div>
                          </a> */}
                        </CardBody>
                      </div>
                    </Card>
                  </Col>
                </Row>
                <Row className="items-row">
                  <Col className="ml-auto" md="4" sm="6">
                    <Card className="card-plain text-center">
                      <div className="card-image">
                        <a href="#pablo" onClick={(e) => e.preventDefault()}>
                          <img
                            alt="..."
                            className="img-rounded img-responsive"
                            src={require("assets/img/disc4.jpeg")}
                          />
                        </a>
                        <CardBody className="details-center">
                          {/* <a href="#pablo" onClick={(e) => e.preventDefault()}>
                            <div className="author">
                              <img
                                alt="..."
                                className="img-circle img-no-padding img-responsive"
                                src={require("assets/img/faces/ayo-ogunseinde-2.jpg")}
                              />
                              <div className="text">
                                <span className="name">Tom Hank</span>
                                <div className="meta">Drawn on 23 Jan</div>
                              </div>
                            </div>
                          </a> */}
                        </CardBody>
                      </div>
                    </Card>
                  </Col>
                  <Col md="3" sm="6">
                    <Card className="card-plain text-center">
                      <div className="card-image">
                        <a href="#pablo" onClick={(e) => e.preventDefault()}>
                          <img
                            alt="..."
                            className="img-rounded img-responsive"
                            src={require("assets/img/disc6.jpeg")}
                          />
                        </a>
                        <CardBody className="details-center">
                          {/* <a href="#pablo" onClick={(e) => e.preventDefault()}>
                            <div className="author">
                              <img
                                alt="..."
                                className="img-circle img-no-padding img-responsive"
                                src={require("assets/img/faces/clem-onojeghuo-2.jpg")}
                              />
                              <div className="text">
                                <span className="name">Tom Banks</span>
                                <div className="meta">Drawn on 23 Jan</div>
                              </div>
                            </div>
                          </a> */}
                        </CardBody>
                      </div>
                    </Card>
                  </Col>
                  <Col className="mr-auto d-sm-block" md="3">
                    <Card className="card-plain text-center">
                      <div className="card-image">
                        <a href="#pablo" onClick={(e) => e.preventDefault()}>
                          <img
                            alt="..."
                            className="img-rounded img-responsive"
                            src={require("assets/img/disc2.jpeg")}
                          />
                        </a>
                        <CardBody className="details-center">
                          {/* <a href="#pablo" onClick={(e) => e.preventDefault()}>
                            <div className="author">
                              <img
                                alt="..."
                                className="img-circle img-no-padding img-responsive"
                                src={require("assets/img/flume.jpg")}
                              />
                              <div className="text">
                                <span className="name">Flume</span>
                                <div className="meta">Drawn on 4 Aug</div>
                              </div>
                            </div>
                          </a> */}
                        </CardBody>
                      </div>
                    </Card>
                  </Col>
                </Row>
                <Row className="items-row">
                <Col md="4" sm="6">
                    <Card className="card-plain text-center">
                      <div className="card-image">
                        <a href="#pablo" onClick={(e) => e.preventDefault()}>
                          <img
                            alt="..."
                            className="img-rounded img-responsive"
                            src={require("assets/img/disc13.jpeg")}
                          />
                        </a>
                        <CardBody className="details-center">
                          {/* <a href="#pablo" onClick={(e) => e.preventDefault()}>
                            <div className="author">
                              <img
                                alt="..."
                                className="img-circle img-no-padding img-responsive"
                                src={require("assets/img/placeholder.jpg")}
                              />
                              <div className="text">
                                <span className="name">Banks</span>
                                <div className="meta">Drawn on 3 Mar</div>
                              </div>
                            </div>
                          </a> */}
                        </CardBody>
                      </div>
                    </Card>
                  </Col>
                  <Col md="4" sm="6">
                    <Card className="card-plain text-center">
                      <div className="card-image">
                        <a href="#pablo" onClick={(e) => e.preventDefault()}>
                          <img
                            alt="..."
                            className="img-rounded img-responsive"
                            src={require("assets/img/disc11.jpeg")}
                          />
                        </a>
                        <CardBody className="details-center">
                          {/* <a href="#pablo" onClick={(e) => e.preventDefault()}>
                            <div className="author">
                              <img
                                alt="..."
                                className="img-circle img-no-padding img-responsive"
                                src={require("assets/img/placeholder.jpg")}
                              />
                              <div className="text">
                                <span className="name">Banks</span>
                                <div className="meta">Drawn on 3 Mar</div>
                              </div>
                            </div>
                          </a> */}
                        </CardBody>
                      </div>
                    </Card>
                  </Col>
                  <Col className="mr-auto" md="4" sm="6">
                    <Card className="card-plain text-center">
                      <div className="card-image">
                        <a href="#pablo" onClick={(e) => e.preventDefault()}>
                          <img
                            alt="..."
                            className="img-rounded img-responsive"
                            src={require("assets/img/disc12.jpeg")}
                          />
                        </a>
                        <CardBody className="details-center">
                          {/* <a href="#pablo" onClick={(e) => e.preventDefault()}>
                            <div className="author">
                              <img
                                alt="..."
                                className="img-circle img-no-padding img-responsive"
                                src={require("assets/img/faces/erik-lucatero-2.jpg")}
                              />
                              <div className="text">
                                <span className="name">Tom Hanks</span>
                                <div className="meta">Drawn on 23 Jan</div>
                              </div>
                            </div>
                          </a> */}
                        </CardBody>
                      </div>
                    </Card>
                  </Col>
                </Row>
               
              </Container>

            </div>
          </div>
        </div>
      </div>
      <FooterBlack />
    </>
  );
}

export default Discover;
